// "Add to bag · $18.00" on the product page. The total follows the quantity and the purchase
// choice (one-time or subscription price). The button keeps its own words; this adds the amount
// through a data attribute that gilly.css shows after the label.
const format = (cents) =>
  new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD',
  }).format(cents / 100);

function refresh() {
  for (const form of document.querySelectorAll('form[id^="BuyButtons-ProductForm-"]')) {
    const formId = form.getAttribute('id');
    const choice = document.querySelector(`input[name="selling_plan"][form="${formId}"]:checked`);
    if (!choice?.dataset.priceCents) continue;
    const quantity = Math.max(1, Number(form.elements.namedItem('quantity')?.value) || 1);
    const total = format(Number(choice.dataset.priceCents) * quantity);
    for (const button of form.querySelectorAll('button[name="add"]')) button.dataset.gillyPrice = total;
  }
}

for (const type of ['change', 'input', 'quantity-selector:update']) {
  document.addEventListener(type, () => queueMicrotask(refresh));
}
document.addEventListener('shopify:product:select', (event) => {
  Promise.resolve(event.promise).finally(() => setTimeout(refresh, 50));
});
refresh();
